module.exports = __webpack_public_path__ + "static/img/Task.3fa5c75.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Task.png
// module id = X0Sq
// module chunks = 1